// extracted by mini-css-extract-plugin
export default {"button":"index_button__NzC4j","copyToClipboard":"index_copyToClipboard__ywKaz","token":"index_token__6wYH8","submitButton":"index_submitButton__XHkNp"};